import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { CustomTooltip, formatLargeNumber } from "./utils";
import { AnalyticsEmptyState } from "./AnalyticsStates";

export const AnalyticsDailyChart = ({ data }) => {
  if (!data || data.length === 0) {
    return <AnalyticsEmptyState type="no_hourly" />;
  }

  return (
    <Card className="bg-card border-border/50">
      <CardHeader>
        <CardTitle className="text-sm uppercase">Mensajes por Dia</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={240}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis
              dataKey="date"
              tick={{ fontSize: 10 }}
              tickFormatter={(v) => v.slice(5)}
            />
            <YAxis tick={{ fontSize: 10 }} />
            <Tooltip content={<CustomTooltip />} />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Bar
              dataKey="incoming"
              name="Recibidos"
              fill="#10b981"
              radius={[3, 3, 0, 0]}
            />
            <Bar
              dataKey="outgoing"
              name="Enviados"
              fill="#3b82f6"
              radius={[3, 3, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export const AnalyticsHourlyChart = ({ data, insights }) => {
  if (!data || data.length === 0) {
    return <AnalyticsEmptyState type="no_hourly" />;
  }

  return (
    <Card className="bg-card border-border/50">
      <CardHeader>
        <CardTitle className="text-sm uppercase">Distribucion Horaria</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <ResponsiveContainer width="100%" height={240}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis
              dataKey="hour"
              tick={{ fontSize: 10 }}
              angle={-45}
              textAnchor="end"
              height={60}
            />
            <YAxis tick={{ fontSize: 10 }} />
            <Tooltip content={<CustomTooltip />} />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Bar
              dataKey="incoming"
              name="Recibidos"
              fill="#10b981"
              radius={[3, 3, 0, 0]}
            />
            <Bar
              dataKey="outgoing"
              name="Enviados"
              fill="#3b82f6"
              radius={[3, 3, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>

        {insights && (
          <div className="grid grid-cols-3 gap-3 text-xs">
            <div className="bg-emerald-50 border border-emerald-200 rounded p-3">
              <p className="font-medium text-emerald-800">Pico</p>
              <p className="text-emerald-700 font-mono">
                {insights.peak_hour} · {insights.peak_count} msgs
              </p>
            </div>
            <div className="bg-blue-50 border border-blue-200 rounded p-3">
              <p className="font-medium text-blue-800">Promedio</p>
              <p className="text-blue-700 font-mono">
                {insights.average_hourly} msgs/hora
              </p>
            </div>
            <div className="bg-amber-50 border border-amber-200 rounded p-3">
              <p className="font-medium text-amber-800">Diferencia</p>
              <p className="text-amber-700 font-mono">
                +{insights.peak_vs_avg_diff} msgs
              </p>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
